import { getAssistedAffiliationDraftService } from "./getAssistedAffiliationDraftService";
import { updateAssistedAffiliationDraftService } from "./updateAssistedAffiliationDraftService";
import { AssistedAffiliationDraft } from "./types";

const REQUEST_CANCELLED_STATUS = "REQUEST_CANCELLED";

/**
 * Rechaza una solicitud: cambia su estado a cancelada y deja el resto de sus datos intactos.
 * @param documentNumber - Identificación con la que el servicio resuelve el registro.
 * @returns Lo que responda el guardado, que hoy viene vacío. Relanza el error para que la pantalla
 * lo traduzca.
 *
 * Consulta la solicitud antes de guardarla porque el endpoint REEMPLAZA el objeto completo: armar
 * el cuerpo aquí, sin haberla leído, sobrescribiría todo lo que ya tenía.
 */
export const rejectAssistedAffiliationDraftService = async (
  documentNumber: string
): Promise<AssistedAffiliationDraft | null> => {
  const draft = await getAssistedAffiliationDraftService(documentNumber);

  // Si la consulta no trae la solicitud, guardar mandaría un cuerpo casi vacío al endpoint que
  // reemplaza el registro completo, es decir la borraría. Falla a la vista en lugar de eso.
  if (!draft) {
    throw new Error(
      `No se encontró la solicitud ${documentNumber} para rechazarla.`
    );
  }

  return updateAssistedAffiliationDraftService({
    ...draft,
    status: REQUEST_CANCELLED_STATUS,
  });
};
